import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalIaModulePage } from './modal-ia-module.page';

const routes: Routes = [
  {
    path: '',
    component: ModalIaModulePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalIaModulePageRoutingModule {}
